let resumeData = {
  imagebaseurl: "http://localhost:3000/",
  name: "Juan Antonio Mayoral Gutiérrez",
  role: "Software Architect"
};
export default resumeData;
